import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=ef60d356&scoped=true&lang=pug"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"
import style0 from "./Services.vue?vue&type=style&index=0&id=ef60d356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef60d356",
  null
  
)

export default component.exports